import { Button } from "@/components/ui/button";
import ProductGrid from "@/components/products/product-grid";
import type { ActiveTab } from "@/components/products/products-client-wrapper";
import type { ProductDetailsInfo } from "@/lib/bagisto/types";

interface ProductsListingProps {
  products: ProductDetailsInfo[];
  activeTab: ActiveTab;
  onTabChange: (tab: ActiveTab) => void;
  isLoading?: boolean;
}

const TABS: { label: string; value: ActiveTab }[] = [
  { label: "GUNI WHEEL", value: "guni-wheel" },
  { label: "GUNI WHEEL X", value: "guni-wheel-x" },
] as const;

export default function ProductsListing({
  products,
  activeTab,
  onTabChange,
  isLoading = false,
}: ProductsListingProps) {
  return (
    <section className="bg-background-50 px-4 sm:px-6 lg:px-10 py-[60px] xl:py-[100px]">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col gap-8 xl:gap-[60px]">

        {/* Heading */}
        <div className="flex flex-col items-center gap-4 xl:gap-[30px] text-center w-full xl:h-[160px]">
          <h2 className="font-oswald font-medium text-[32px] sm:text-[42px] xl:text-[60px] leading-[1.2] xl:leading-[80px] tracking-[0.2px] uppercase text-neutral-500">
            Our Universal Wheel Products
          </h2>
          <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300 max-w-[90%] lg:max-w-[700px] xl:max-w-[953px]">
            Guniwheel offers a complete range of universal temporary wheels
            engineered to fit different vehicle types — from small cars to
            heavy-duty trucks. Choose the model that matches your workshop needs.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center gap-4 xl:gap-5 w-full xl:w-[620px] xl:h-[60px] mx-auto">
          {TABS.map((tab) => (
            <Button
              key={tab.value}
              onClick={() => onTabChange(tab.value)}
              className={`w-full xl:w-[300px] h-[60px] px-6 py-[10px] rounded-[10px] font-oswald font-medium text-[16px] xl:text-[20px] hover:text-white leading-[100%] tracking-[0.2px] uppercase transition-all cursor-pointer shadow-none border-b-2 active:scale-90 active:brightness-100 ${
                activeTab === tab.value
                  ? "bg-primary-500 text-white border-primary-500"
                  : "bg-background text-neutral-500 border-transparent"
              }`}
            >
              {tab.label}
            </Button>
          ))}
        </div>

        {/* Product Grid */}
        <ProductGrid products={products} isLoading={isLoading} />

      </div>
    </section>
  );
}